// Libraries
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
// Components
import TeamMemberDetailCard from './team-member-detail-card';

import Modal from '../../index';
import { modalActions } from '~/redux/actions/modal-actions';
import { ContentSpinner } from '../../../../ui/layout/spinner';
import { connect } from '../../../../../../node_modules/react-redux';

let afterClose;

class IndividualDetailModal extends PureComponent {
	constructor(props) {
		super(props);
		this.onClose = this.onClose.bind(this);

		this.state = {
			userDetails: [],
			name: null,
			joinedDate: null,
			lastActivity: null,
			distance: 0,
			ranking: 0,
		};
	}

	/**
	 * Closes the window, when the user clicks on the 'cancel' button
	 *
	 * @memberof TeamDetailModal
	 */
	onClose() {
		modalActions.hideModal();
		this.props.dispatch(modalActions.hideModal());

		if (afterClose) {
			afterClose();
		}
	}

	/**
	 * Renders the list of team members
	 *
	 * @param {*} team
	 * @returns
	 * @memberof MyTeam
	 */
	renderUserDetails(
		photoUrl,
		userId,
		userName,
		isCaptain,
		joinedDate,
		lastActivity,
		distance,
		ranking,
		isCaptainSignedIn,
	) {
		if (userId) {
			return (
				<TeamMemberDetailCard
					isCaptainSignedIn={isCaptainSignedIn}
					userId={userId}
					className="large-12 small-12"
					isCaptain={isCaptain}
					isUser={true}
					isRequired={false}
					photo={`${photoUrl}`}
					name={`${userName}`}
					distance={distance ? distance / 1000 : 0}
					position={1}
					lastActivity={`${distanceInWordsToNow(lastActivity, { addSuffix: true })}`}
					ranking={ranking}
				/>
			);
		} else {
			return <ContentSpinner />;
		}
	}

	render() {
		const { onClose } = this.props;
		const {
			modalTitle,
			modalSubtitle,
			photoUrl,
			userId,
			userName,
			isCaptain,
			joinedDate,
			lastActivity,
			distance,
			ranking,
			isCaptainSignedIn,
		} = this.props;

		return (
			<Modal modalTitle={`${modalTitle}`} modalSubtitle={`${modalSubtitle}`} onClose={onClose} center>
				<Wrapper className="grid-x grid-margin-x">
					{this.renderUserDetails(
						photoUrl,
						userId,
						userName,
						isCaptain,
						joinedDate,
						lastActivity,
						distance,
						ranking,
						isCaptainSignedIn,
					)}
				</Wrapper>
			</Modal>
		);
	}
}

function mapStateToProps(state) {
	return {
		modalTitle: state.modal.properties.modalTitle,
		modalSubtitle: state.modal.properties.modalSubtitle,
		photoUrl: state.modal.properties.photoUrl,
		userId: state.modal.properties.userId,
		userName: state.modal.properties.userName,
		isCaptain: state.modal.properties.isCaptain,
		teamName: state.modal.properties.teamName,
		joinedDate: state.modal.properties.joinedDate,
		lastActivity: state.modal.properties.lastActivity,
		distance: state.modal.properties.distance,
		ranking: state.modal.properties.ranking,
		isCaptainSignedIn: state.modal.properties.isCaptainSignedIn,
	};
}

const Wrapper = styled.div`
	height: 50vh;
	min-height: auto;

	max-height: ${rem('560px')};
	overflow-y: auto;

	@media ${props => props.theme.breakpointLarge} {
		height: auto;
		max-height: auto;
	}
`;

IndividualDetailModal.propTypes = {
	modalTitle: PropTypes.string,
	onClose: PropTypes.func,
};

export default connect(mapStateToProps)(IndividualDetailModal);



// WEBPACK FOOTER //
// ./src/components/general/modal/types/individual-detail/index.jsx